import updateObject from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import {initialGroupsTable, initialUsersNotInGroup} from "./helper";

const initialState = {
    groupsTable: initialGroupsTable,
    createUpdateDeleteLoading: false,
    usersNotInGroup: initialUsersNotInGroup,
};
const setGroupManagementTable = (state, action) => updateObject(state, {
    groupsTable: updateObject(
        state.groupsTable,
        {[action.key]: action.value},
    ),
});

const setCreateUpdateDeleteLoading = (state, action) => updateObject(state, {
    createUpdateDeleteLoading: action.value,
});

const setUsersNotInGroup = (state, action) => updateObject(state, {
    usersNotInGroup: updateObject(
        state.usersNotInGroup,
        {[action.key]: action.value},
    ),
});

const groupManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_GROUP_MANAGEMENT_TABLE:
            return setGroupManagementTable(state, action)
        case actionTypes.CREATE_UPDATE_DELETE_GROUP_LOADING:
            return setCreateUpdateDeleteLoading(state, action)
        case actionTypes.GET_USERS_NOT_IN_GROUP:
            return setUsersNotInGroup(state, action)
        default:
            return state;
    }
};

export default groupManagementReducer;